<template>
  <b-card class="mt-3" header-tag="header">
    <template #header>
      <div>
        <div class="child inline-block-child">
          <img
            v-b-tooltip.hover
            title="General"
            width="20px"
            src="../../../assets/images/disks.svg"
          />
        </div>
        <div class="child inline-block-child">
          <h6 class="mb-0">Hard Disk</h6>
        </div>
      </div>
    </template>
    <div :class="{ hasError: v.$error }">
      <b-form-group
        label="Disk size (GiB):"
        label-for="nested-street"
        label-cols-sm="2"
        label-align-sm="right"
      >
        <b-form-input
          id="disk"
          type="number"
          v-model="disk"
          @input="v.$touch()"
        ></b-form-input>

        <label class="placeholderError"> Mínim 1GB i màxim 30GB </label>
      </b-form-group>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "1",
    },
    v: {
      type: Object,
      required: true,
    },
  },
  computed: {
    disk: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
<style scoped>
.inline-block-child {
  display: inline-block;
  margin-right: 10px;
}
</style>